import { MarkdownRenderer } from '@/features/chat/MarkdownRenderer';

import type { AIUploadQuestionData } from '../questionNormalizer';
import { FilePreview } from './FilePreview';
import styles from './GradingFeedback.module.css';

interface GradingFeedbackProps {
  question: AIUploadQuestionData;
  showFeedback: boolean;
  showScore: boolean;
}

function formatPoints(value: number) {
  return Number.isInteger(value) ? String(value) : value.toFixed(2).replace(/\.?0+$/, '');
}

export function GradingFeedback({
  question,
  showFeedback,
  showScore,
}: GradingFeedbackProps) {
  const feedback = question.gradingDetails?.feedback;
  const manualFeedback = question.gradingDetails?.manualFeedback;

  if (!question.submittedFileUrl && !showScore && !showFeedback) {
    return null;
  }

  return (
    <section className={styles.root} aria-label="AI Upload grading result">
      {question.submittedFileUrl ? (
        <div className={styles.block}>
          <h4 className={styles.heading}>Your submission</h4>
          <FilePreview
            fileName={question.submittedFileName}
            fileUrl={question.submittedFileUrl}
          />
        </div>
      ) : null}

      {showScore && question.scoreEarned !== undefined ? (
        <p className={styles.score}>
          Score: {formatPoints(question.scoreEarned)} /{' '}
          {formatPoints(question.pointsPossible)}
        </p>
      ) : null}

      {showFeedback && (feedback || manualFeedback) ? (
        <div className={styles.block}>
          <h4 className={styles.heading}>Feedback from KAI</h4>
          {feedback ? (
            <div className={styles.feedback}>
              <MarkdownRenderer content={feedback} />
            </div>
          ) : null}
          {manualFeedback ? (
            <div className={styles.feedback}>
              <MarkdownRenderer content={manualFeedback} />
            </div>
          ) : null}
        </div>
      ) : null}
    </section>
  );
}
